<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Tramite digital</h5>
                  <p>Registrarse.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt class="rounded-circle" height="34" />
                  </span>
                </div>
              </router-link>
            </div>

            <b-alert
              v-model="registerSuccess"
              class="mt-3"
              variant="success"
              dismissible
            >Registration successfull.</b-alert>

            <b-alert
              v-model="isRegisterError"
              class="mt-3"
              variant="danger"
              dismissible
            >{{regError}}</b-alert>

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >{{notification.message}}</div>

            <b-form class="p-2" @submit.prevent="tryToRegisterIn">
              <b-form-group id="email-group" label="Usuario" label-for="username">
                <b-form-input
                  id="username"
                  v-model="user.username"
                  type="text"
                  placeholder="Ingrese usuario"
                  :class="{ 'is-invalid': submitted && $v.user.username.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.username.required"
                  class="invalid-feedback"
                >Username is required.</div>
              </b-form-group>

              <b-form-group id="fullname-group" label="Email" label-for="email">
                <b-form-input
                  id="email"
                  v-model="user.email"
                  type="email"
                  placeholder="Ingrese email"
                  :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                ></b-form-input>
                <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                  <span v-if="!$v.user.email.required">Email is required.</span>
                  <span v-if="!$v.user.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group id="password-group" label="Contraseña" label-for="password">
                <b-form-input
                  id="password"
                  v-model="user.password"
                  type="password"
                  placeholder="Ingrese contraseña"
                  :class="{ 'is-invalid': submitted && $v.user.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.password.required"
                  class="invalid-feedback"
                >La contraseña es requerida</div>
              </b-form-group>

              <div class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block">
                  <b-spinner small v-show="isLoading"/>
                  Registrarse
                </b-button>
              </div>

              <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div class="mt-4 text-center">
                <p class="mb-0">
                  By registering you agree to the Skote
                  <a
                    href="javascript: void(0);"
                    class="text-primary"
                  >Terms of Use</a>
                </p>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Already have an account ?
            <router-link tag="a" to="/login" class="font-weight-medium text-primary">Login</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i
              class="mdi mdi-heart text-danger"
            ></i> by Themesbrand
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>


<script>
  import {
    authMethods,
    authFackMethods,
    notificationMethods
  } from "@/state/helpers";
  import Layout from "../../layouts/auth";
  import appConfig from "@/app.config";
  import { mapState } from "vuex";

  import { required, email } from "vuelidate/lib/validators";

  /**
   * Register component
   */
  export default {
    page: {
      title: "Register",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout },
    data() {
      return {
        user: { username: "", email: "", password: "" },
        submitted: false,
        regError: null,
        tryingToRegister: false,
        isRegisterError: false,
        registerSuccess: false,
        isLoading:false
      };
    },
    validations: {
      user: {
        username: { required },
        email: { required, email },
        password: { required }
      }
    },
    computed: {
      ...mapState("authfack", ["status"]),
      notification() {
        return this.$store ? this.$store.state.notification : null;
      }
    },
    methods: {
      ...authMethods,
      ...authFackMethods,
      ...notificationMethods,
      // Try to register the user in with the email, username
      // and password they provided.
      tryToRegisterIn() {
        this.submitted = true;
        // stop here if form is invalid
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        } else {

          this.isLoading=true;
          this.axios.post(process.env.VUE_APP_BACKEND+'/users/register',
                  {
                    model:this.user
                  })
                  .then((response)=>
                  {
                    if(response.data.success)
                    {

                      this.$swal('Ok',"Se agrego o modifico correctamente",'success');
                      this.isLoading=false;

                    }
                    else
                    {
                      this.$swal('Error',"Error guardando ",'warning');
                      this.isLoading=false;
                    }
                  })
                  .catch(()=>{
                    this.$swal('error','error guardando','error');
                    this.isLoading=false;
                  })
                  .finally(()=>
                  {
                    //this.$refs.panelprincipal.resetReload();
                  });

        }
      }
    }
  };
</script>
